var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "back-link", on: { click: _vm.handleBackClick } },
    [
      _c(
        "router-link",
        { attrs: { to: { path: "/" } } },
        [
          _c("font-awesome-icon", { attrs: { icon: ["fas", "arrow-left"] } }),
          _vm._v(" "),
          _c("span", { staticClass: "pl-1" }, [_vm._v("Back")])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0dbe9660", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dbe9660","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/buttons/BackToHomeButton.vue
// module id = null
// module chunks = 